// extracted by mini-css-extract-plugin
export default {"avatarWithDetails":"cDxdes3kbPvgEV5BYCcT","title":"ZWxHBJs52ban5Pt21ial","details":"CYMPcOT3IqeBDQIGSYo7"};